// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"eddafe0f","239":"649e1939","397":"b954a1eb","455":"c90a37a5"}[chunkId] + ".chunk.js";
};